<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        <b>Add {{ schoolUser.type === 'ST' ? 'Teacher' : 'School Admin' }}</b>
        <span v-if="schoolName"> &mdash; {{ schoolName }}</span>
      </p>
    </header>
    <section class="modal-card-body">
      <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>

      <div class="columns is-multiline">
        <div class="column is-12">
          <b-field label="Role">
            <b-select v-model="schoolUser.type" expanded>
              <option value="SA">School Admin</option>
              <option value="ST">Teacher</option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field label="Name *">
            <b-input v-model="schoolUser.name" placeholder="Name" required></b-input>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field label="Email *">
            <b-input v-model="schoolUser.email" placeholder="Email" type="email" required></b-input>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field label="Mobile *">
            <b-input v-model="schoolUser.mobile" placeholder="Mobile" required></b-input>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field label="Password *">
            <b-input v-model="schoolUser.password" type="password" placeholder="Password" required></b-input>
          </b-field>
        </div>
        <div class="column is-12">
          <b-button
            @click="proceed()"
            class="btn-center"
            type="is-primary"
          >Create {{ schoolUser.type === 'ST' ? 'Teacher' : 'School Admin' }}</b-button>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">Close</button>
    </footer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'set-school-admin',
  props: {
    school_id: { type: String, required: true },
    schoolName: { type: String, default: '' },
    defaultType: { type: String, default: 'SA' }
  },
  data(){
    return {
      isLoading : false,
      schoolUser : {
        name : '',
        email : '',
        mobile : '',
        password : '',
        type : this.defaultType
      }
    }
  },
  computed : {
    ...mapGetters(['getTeacherToken'])
  },
  methods : {
    ...mapActions(['createSchoolAdminForSchool']),
    proceed(){
      if(!this.schoolUser.name || !this.schoolUser.email || !this.schoolUser.mobile || !this.schoolUser.password){
        this.$buefy.toast.open({ message: 'All fields are required', type: 'is-warning' })
        return
      }
      this.isLoading = true
      this.createSchoolAdminForSchool({
        id: this.school_id,
        schoolUser: this.schoolUser,
        token: this.getTeacherToken
      }).then(res => {
        this.isLoading = false
        if(res && res.success){
          this.$emit('over')
          this.$buefy.toast.open({ message: res.msg || 'Created successfully', type: 'is-success' })
        }else{
          this.$buefy.toast.open({ message: (res && res.msg) || 'Could not create user', type: 'is-danger' })
        }
      }).catch(err => {
        this.isLoading = false
        this.$buefy.toast.open({
          message: (err.response && err.response.data && err.response.data.msg) || 'Could not create user',
          type: 'is-danger'
        })
      })
    }
  }
}
</script>
